import IsLocalStorageAvil from './isLocalStorage';

function IsNecessaryCookieEnabled() {
    //@ts-ignore
    if (navigator.globalPrivacyControl) {
        return false;
    }

    if (IsLocalStorageAvil()) {
        if (!window.localStorage.getItem('motoragazzi_cookies')) {
            return false;
        }

        return true;
    }

    // if browser does not support localStorage
    return false;
}

function IsAnalyticsCookieEnabled() {
    //@ts-ignore
    if (navigator.globalPrivacyControl) {
        return false;
    }

    if (IsLocalStorageAvil()) {
        if (
            window.localStorage.getItem('motoragazzi_cookies_analytics') === '0' ||
            !window.localStorage.getItem('motoragazzi_cookies')
        ) {
            return false;
        }

        return true;
    }

    // if browser does not support localStorage
    return false;
}

function IsThirdPartyCookieEnabled() {
    //@ts-ignore
    if (navigator.globalPrivacyControl) {
        return false;
    }

    if (IsLocalStorageAvil()) {
        if (
            window.localStorage.getItem('motoragazzi_cookies_performance') === '0' ||
            !window.localStorage.getItem('motoragazzi_cookies')
        ) {
            return false;
        }

        return true;
    }

    // if browser does not support localStorage
    return false;
}

export {IsNecessaryCookieEnabled, IsAnalyticsCookieEnabled, IsThirdPartyCookieEnabled};
